import { Space, theme } from 'antd';
import { FC } from 'react';
import { PatchCheckFill, PatchExclamationFill } from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';

import { AppCardList, DomainPunycode, MainDomainIcon } from '@/common/components';
import { AppRoutes, BaseQueryParams } from '@/common/interfaces';

import { useCurrentRouteType } from '@/common/hooks';
import { useGetAllSearchConsoleSitemapDomainsQuery } from '@/modules/Domains';

interface Props {
  currentPage: number;
  sitemapDomainsItems: BaseQueryParams<typeof useGetAllSearchConsoleSitemapDomainsQuery>['data']['items'];
  sitemapDomainsTotalItems: BaseQueryParams<typeof useGetAllSearchConsoleSitemapDomainsQuery>['data']['meta']['totalItems'];
  sitemapDomainsItemsPerPage: BaseQueryParams<typeof useGetAllSearchConsoleSitemapDomainsQuery>['data']['meta']['itemsPerPage']
  isLoading: boolean;
  handleChangePage: (page: number) => void;
}

export const SearchConsoleSitemapListView: FC<Props> = ({
  currentPage,
  sitemapDomainsItems,
  sitemapDomainsTotalItems,
  sitemapDomainsItemsPerPage,
  isLoading,
  handleChangePage
}) => {
  const { token } = theme.useToken();
  const domainId = useParams()['*'];
  const siteId = useParams()?.siteId ?? '';
  const { routeType } = useCurrentRouteType();

  return (
    <AppCardList
      headerTitle={ null }
      pagination={{
        current: currentPage,
        total: sitemapDomainsTotalItems,
        pageSize: sitemapDomainsItemsPerPage,
        disabled: isLoading,
        onChange: (page: number) => handleChangePage(page)
      }}
      selectedKey={ domainId }
      rowKey="id"
      titleKey="name"
      grid={{
        gutter: 16,
        xs: 1,
        sm: 1,
        md: 1,
        lg: routeType === 'drawer' ? 1 : 2,
        xl: routeType === 'drawer' ? 1 : 2,
        xxl: routeType === 'drawer' ? 2 : 3
      }}
      navigateTo={ ({ id }) => ({ to: AppRoutes.SiteSearchConsoleSitemapById.replace(':siteId', siteId).replace(':domainId', id) }) }
      list={ sitemapDomainsItems }
      titleRender={ (title, { isSitesMain }) => (
        <Space>
          { isSitesMain && <MainDomainIcon color={ token.colorPrimary } title="Main domain"/> }
          <DomainPunycode domainName={ title }/>
        </Space>
      ) }
      content={ (record) => (
        <>
          {
            record.isGoogleVerificated
              ? <Space><PatchCheckFill color={ token.colorSuccess }/><span>Верифіковано</span></Space>
              : <Space><PatchExclamationFill color={ token.colorError }/><span>Не верифіковано</span></Space>
          }
        </>
      ) }
    />
  );
};
